export default {
  metadata: {
    version: '1.0.0',
    id: 'search-result-text-1.0.0',
    name: 'JDSSearchResultText'
  },
  hierarchy: {
    'jds-text': []
  },
  base: {
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1,
      behavior: {
        hover: {
          color: '{text_21}'
        }
      }
    }
  },
  variant: {
    bold: {
      true: {
        'jds-text': {
          'font-family': '{text_137}',
          'font-size': '{text_136}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      bold: {
        values: [false, true]
      }
    },
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'text'
        }
      }
    }
  }
};
